import { render, staticRenderFns } from "./BaseIconTooltip.vue?vue&type=template&id=61105f51&"
import script from "./BaseIconTooltip.vue?vue&type=script&lang=js&"
export * from "./BaseIconTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports